import React from 'react'
import tachyon from '../utils/tachyon'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import AriaTooltips from './AriaTooltips';

const eventHasButton = (hit) => {
    if (hit.hasBookingButton === true) {
        return <a className={"c-btn c-btn--red c-btn--small " + (hit.bookingLabel === 'Sold Out' ? 'c-btn--soldout' : '')} href={hit.bookingUrl}><i className="far fa-ticket-alt" aria-hidden="true"></i> {hit.bookingLabel}</a>;
    }
    return '';
}

/*eslint jsx-a11y/anchor-has-content: 0 */
const Event = ({ hit }) => (
    <section className="c-event-card fadeInUp">
        <a className="c-event-card__link" href={hit.permalink}>
            <figure className="c-event-card__img">
                <LazyLoadImage src={tachyon.fetch(hit.coverUrl, { resize: '600,400', gravity: 'center' })} alt={hit.postTitle}
                    placeholderSrc={tachyon.fetch(hit.coverUrl, { resize: '60,40', gravity: 'center' })} />
            </figure>
        </a>
        <div className="c-event-card__body">
            <h3 className="c-event-card__title">{hit.postTitle}</h3>
            <div className="c-event-card__details">
                <time className="c-event-card__date"><i className="far fa-calendar"></i> {hit.listingDateLabel}</time>
                <div className="c-access-labels">
                    <AriaTooltips access={hit.access || []} />
                </div>
            </div>
            <div className="c-event-card__description c-col-txt-area">{hit.excerpt || ''}</div>

            <div className="c-event-card__bottom-details">
                
                {Array.isArray(hit.seasons) && hit.seasons.map(season => <div key={season.title} className="c-event-card__season"><a  className="c-link" href={season.permalink}>{season.title}</a></div>)}

            </div>
            <div className="c-event-card__actions">

                {eventHasButton(hit)}

                {Array.isArray(hit.venues) && (
                    <div className="c-event-card__venues">
                        <div className="c-event-card__meta c-event-card__venue">
                            {hit.venues.map(venue => <span key={venue}><i className="fal fa-map-marker-alt" aria-hidden="true"></i> {venue}</span>)}
                        </div>
                    </div>
                )}
            </div>

            <a className="c-event-card__cover-link" href={hit.permalink}></a>

        </div>
    </section>
);


export default Event;



// WEBPACK FOOTER //
// ./src/whatson/components/Event.js